module.exports = __webpack_public_path__ + "static/166-f7f8347eb8b14258ab5678a5c29e6512.jpg";